import { Link, useNavigate } from "react-router-dom";
import CommonImageSlider from "./comandata";
import { aboutImages } from "./data";

export function CommonAboutHeader(props){
    const navigate=useNavigate()
return(<div className="ms-1 me-1 grid grid-cols-1  sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 ">
        <div>
            <CommonImageSlider images={props.images}  />
            </div>
<div className="ms-4">
     <h2 className="text-2xl sm:text-3xl lg:text-3xl md:text-3xl xl:text-3xl font-bold leading-tight  text-center">{props.title}</h2>
 <p className="mt-4 m-4 text-justify">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {props.des}</p>


</div>
</div>)
}